import { getElements } from "../utils.js";

export default function InformationDisplayRow(label, data) {
  const localState = {
    animationId: null,
  };

  const wrapper = document.createElement("div");
  wrapper.classList.add("information-display__row");
  wrapper.innerHTML = `
  <label for="">${label}:</label><output data-js='data-display'><span>${data}</span>
      <button data-js="data-display-button"> 
        <i class="copy fi fi-sr-copy-alt"></i>
        <i class="copied fi fi-br-check"></i>
      </button></output>
  `;

  const { dataDisplay, dataDisplayButton } = getElements(wrapper);

  dataDisplayButton.addEventListener("click", () => {
    navigator.clipboard.writeText(data);
    clearTimeout(localState.animationId);

    dataDisplay.classList.add("show-copied");

    localState.animationId = setTimeout(() => {
      dataDisplay.classList.remove("show-copied");
      localState.animationId = null;
    }, 2000);
  });

  return wrapper;
}
